import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class MemberId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): MemberId {
    return new MemberId(value);
  }

  /** キー */
  static get key(): string {
    return 'memberId';
  }

  /** タイプ */
  static get type(): string {
    return 'text';
  }

  /** ラベル */
  static get label(): string {
    return '職員ID';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return 'taro';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
